import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { actionRedirect } from '../helpers/ofertas-helper';
import { useOfertasTracker } from '../helpers/use-ofertas-tracker';
import { CarlineWithOfertas, Oferta } from '../services/ofertas-service/models/ofertas';

export const RedirectCTAs = ({
	oferta,
	carline,
	copy,
	isMobile,
	emphasis,
	trackingRef,
	formTrigger,
}: {
	oferta: Oferta;
	carline: CarlineWithOfertas;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	trackingRef?: string;
	formTrigger: string;
}) => {
	const { featureAppService, userInteractionService } = React.useContext(OfertasContext);
	const [showOneformV1, setShowOneformV1] = useState<boolean>(false);
	const { trackOfertasButtonClick } = useOfertasTracker();

	const handleOnClick = () => {
		const contentId = trackingRef ? `${copy} - ${trackingRef}` : copy;
		const id = copy;
		trackOfertasButtonClick(contentId, oferta, carline, id);

		if (formTrigger === 'es-oneform-v2') {
			actionRedirect(
				userInteractionService,
				`es-oneform-v2-action--open_layer?formName=lead_venta-presupuesto&featureApp=esofertasv2&ofertaId=${oferta.id}&carline=${oferta.carline?.name}`,
			);
		} else {
			setShowOneformV1(true);
		}
	};

	const renderOneformV1 = () => {
		const featureApp = showOneformV1 ? featureAppService.featureAppConfigurations[formTrigger] : undefined;
		if (!featureApp) {
			return null;
		}

		return (
			<FeatureAppLoader
				{...featureApp}
				featureAppId={`${featureApp.name}:oneform`}
				done={() => setShowOneformV1(false)}
				beforeCreate={(env) => {
					const faContentService = env.featureServices['fa-content-service'] as { content: unknown } | undefined;
					if (faContentService) {
						faContentService.content = {
							featureApp: 'es-ofertas',
							oferta: oferta,
						};
					}
					const apiKeyProvider = env.featureServices['api-key-provider'] as { apiKey?: string } | undefined;
					if (apiKeyProvider) {
						apiKeyProvider.apiKey = featureApp.apiKey;
					}
					const tracking = env.featureServices.tracking as { contextualEventData?: unknown } | undefined;
					if (tracking) {
						tracking.contextualEventData = {
							event: {
								environment: {
									featureAppId: featureApp.trackingId,
								},
							},
						};
					}
				}}
			/>
		);
	};

	return (
		<>
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={handleOnClick}
			>
				{copy}
			</CTA>
			{renderOneformV1()}
		</>
	);
};
